import { render, staticRenderFns } from "./Scrolly.vue?vue&type=template&id=6cf212c0&scoped=true&"
import script from "./Scrolly.vue?vue&type=script&lang=js&"
export * from "./Scrolly.vue?vue&type=script&lang=js&"
import style0 from "./Scrolly.vue?vue&type=style&index=0&id=6cf212c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf212c0",
  null
  
)

export default component.exports